<density-confirmation-dialog
    [isOpen]="isOpen"
    [title]="'PAGE.ANALYSISEARCH.DELETE_ANALYSIS_DIALOG.TITLE.LBL' | translate"
    [message]="'PAGE.ANALYSISEARCH.DELETE_ANALYSIS_DIALOG.MESSAGE.TXT' | translate"
    [innerHtmlMessage]="true"
    [confirmLabel]="'PAGE.ANALYSISEARCH.DELETE_ANALYSIS_DIALOG.CONFIRM.LBL' | translate"
    [cancelLabel]="'PAGE.ANALYSISEARCH.DELETE_ANALYSIS_DIALOG.CANCEL.LBL' | translate"
    (isOpenChange)="onOpenChange($event)"
    (confirm)="confirm()">
</density-confirmation-dialog>
